import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Checkbox, Dimmer, Form, Header, Input, Loader } from 'semantic-ui-react';
import { isValidAllEmailAddress, isValidPhoneNumber, isPCICompliantForPayments } from '../../containers/Utils';
import CountrySelector from '../Countries';
import DateOfBirth from '../DateOfBirth';
import StateSelector from '../States';
import './styles.css';


class EditMember extends Component {
  static propTypes = {
    memberRequest: PropTypes.object,
    saveMember: PropTypes.func,
    createSecondaryForAccount: PropTypes.func,
    setMemberRequest: PropTypes.func.isRequired,
    removeMemberRequest: PropTypes.func.isRequired,
    setSuccessMessage: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    validateAddress: PropTypes.func.isRequired,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return null;
  }

  constructor(props) {
    super(props);
    if (isEmpty(props.memberRequest)) {
      this.state = {
        cancel: true,
        view: false,
      };
    } else {
      this.state = {
        member: omit(props.memberRequest, ['dateOfBirth', 'spouseDateOfBirth']),
        spouseInfo: {
          spouseId: props.memberRequest.spouseId,
          spouseFirstName: props.memberRequest.spouseFirstName,
          spouseMiddleName: props.memberRequest.spouseMiddleName,
          spouseLastName: props.memberRequest.spouseLastName,
          spouseEmailAddress: props.memberRequest.spouseEmailAddress,
          spouseBirthMonth: props.memberRequest.spouseBirthMonth,
          spouseBirthDay: props.memberRequest.spouseBirthDay,
          spouseBirthYear: props.memberRequest.spouseBirthYear,
        },
        view: false,
        cancel: false,
      };
      props.removeMemberRequest();
    }
  }

  onChangeValue = (_, data) => {
    const { member } = this.state;
    member[data.name] = data.value;
    this.setState({
      member,
    });
  }

  onChangeSpanishMaterial = (_, data) => {
    const { member } = this.state;
    member.spanishMaterial = data.checked;
    this.setState({
      member,
    });
  }

  onKeyPressExecute = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  didSpouseInfoChange = () => {
    const { member, spouseInfo } = this.state;
    return member.spouseFirstName !== spouseInfo.spouseFirstName ||
      member.spouseMiddleName !== spouseInfo.spouseMiddleName ||
      member.spouseLastName !== spouseInfo.spouseLastName ||
      member.spouseEmailAddress !== spouseInfo.spouseEmailAddress ||
      member.spouseBirthMonth !== spouseInfo.spouseBirthMonth ||
      member.spouseBirthDay !== spouseInfo.spouseBirthDay ||
      member.spouseBirthYear !== spouseInfo.spouseBirthYear;
  }

  isValidateInputs = () => {
    const { setErrorMessage } = this.props;
    const { member } = this.state;
    let errorMessage = '';
    errorMessage += isValidPhoneNumber(member.phoneNumber);
    errorMessage += isValidAllEmailAddress(member.emailAddress, member.spouseEmailAddress);
    if (errorMessage !== '') {
      setErrorMessage(errorMessage.substring(0, errorMessage.length - 2));
      return false;
    }
    return true;
  }

  submit = () => {
    if (this.isValidateInputs()) {
      const { saveMember, setMemberRequest, setSuccessMessage, setErrorMessage, validateAddress } = this.props;
      const { member } = this.state;
      this.setState({
        memberLoading: true,
        loadingMessage: 'Updating Member...',
      });

      const address = {
        addressLine1: member.addressLine1,
        addressLine2: member.addressLine2,
        city: member.city,
        state: member.state,
        zipCode: member.zipCode,
        country: member.country,
      };

      const p = (member.country === 'US' || member.country === '') ? validateAddress(address) : Promise.resolve({});
      p.then((addrResponse) => {
        saveMember({
          variables: {
            member: omit(member, ['__typename', 'expiryDate', 'spouseEmailAddress']),
          },
        })
          .then((response) => {
            if (!this.didSpouseInfoChange()) {
              setMemberRequest({ ...member });
              this.setState({
                member: response.data.saveMember,
                memberLoading: false,
                loadingMessage: undefined,
                view: true,
              });
              setSuccessMessage('Member information updated.');
            } else {
              this.updateSpouseInfo(member)
                .then((spouseResponse) => {
                  setMemberRequest({ ...member });
                  this.setState({
                    member,
                    memberLoading: false,
                    loadingMessage: undefined,
                    view: true,
                  });
                  setSuccessMessage('Member information updated.');
                })
                .catch((err) => {
                  this.setState({
                    memberLoading: false,
                    loadingMessage: undefined,
                  });
                  setErrorMessage(err);
                });
            }
          })
          .catch((err) => {
            this.setState({
              memberLoading: false,
              loadingMessage: undefined,
            });
            setErrorMessage(err);
          });
      })
        .catch((err) => {
          this.setState({
            memberLoading: false,
            loadingMessage: undefined,
          });
          setErrorMessage(err);
        });
    }
  }

  updateSpouseInfo = (member) => {
    const { saveMember, createSecondaryForAccount } = this.props;

    return (member.spouseId !== '' && member.spouseId > '0') ?
      saveMember({
        variables: {
          member: {
            id: member.id,
            personId: member.spouseId,
            firstName: member.spouseFirstName,
            middleName: member.spouseMiddleName,
            lastName: member.spouseLastName,
            phoneNumber: member.phoneNumber,
            addressLine1: member.addressLine1,
            addressLine2: member.addressLine2,
            city: member.city,
            state: member.state,
            zipCode: member.zipCode,
            country: member.country,
            emailAddress: member.spouseEmailAddress,
            birthMonth: member.spouseBirthMonth,
            birthDay: member.spouseBirthDay,
            birthYear: member.spouseBirthYear,
            spanishMaterial: member.spanishMaterial,
            accountIndicator: member.accountIndicator,
            accountStatus: member.accountStatus,
            accountType: member.accountType,
          },
        },
      })
      :
      createSecondaryForAccount({
        variables: {
          input: {
            accountId: member.id,
            primaryPersonId: member.personId,
            firstName: member.spouseFirstName,
            middleName: member.spouseMiddleName,
            lastName: member.spouseLastName,
            addressLine1: member.addressLine1,
            addressLine2: member.addressLine2,
            city: member.city,
            state: member.state,
            zipCode: member.zipCode,
            country: member.country,
            emailAddress: member.spouseEmailAddress,
          },
        },
      });
  }

  handleCancel = () => {
    this.setState({
      cancel: true,
    });
  }

  render() {
    const {
      memberLoading, member, view, cancel, loadingMessage,
    } = this.state;

    if (cancel) {
      return <Redirect to="/search" />;
    }

    if (view) {
      return <Redirect to="/view" />;
    }

    return (
      <div>
        <Dimmer.Dimmable as="div">
          {
            memberLoading &&
            <Dimmer active={memberLoading}>
              <Loader inverted>{loadingMessage || 'Loading Member...'}</Loader>
            </Dimmer>
          }
          <div styleName="details-container">
            <Header as="h2" dividing styleName="edit-header">
              Member Information
              {
                member.expiryDate &&
                <Header.Subheader>
                  Your account is currently paid through {member.expiryDate}
                </Header.Subheader>
              }
              {
                member.autoRenew === 'Y' &&
                <Header.Subheader>
                  Member is currently using Auto Renew
                </Header.Subheader>
              }
              {
                member.autoRenew !== 'Y' &&
                <Header.Subheader>
                  Member is currently not using Auto Renew
                </Header.Subheader>
              }
            </Header>
            <Form>
              <div styleName="member-info">
                <Form.Field
                  control={Input}
                  label="Membership Number"
                  value={member.id}
                  name="membershipNumber"
                  readOnly
                />

                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    label="First Name"
                    value={member.firstName}
                    onChange={this.onChangeValue}
                    name="firstName"
                    required
                    fluid
                    autoComplete="disabled"
                  />
                  <Form.Field
                    control={Input}
                    label="Middle Name"
                    value={member.middleName}
                    onChange={this.onChangeValue}
                    name="middleName"
                    fluid
                    autoComplete="disabled"
                  />
                  <Form.Field
                    control={Input}
                    label="Last Name"
                    value={member.lastName}
                    onChange={this.onChangeValue}
                    name="lastName"
                    required
                    fluid
                    autoComplete="disabled"
                  />
                </Form.Group>
                <DateOfBirth
                  member={member}
                  fieldChangeHandler={this.onChangeValue}
                  memberLevel="primary"
                />
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    label="Mailing Address"
                    value={member.addressLine1}
                    onChange={this.onChangeValue}
                    name="addressLine1"
                    required
                    fluid
                    autoComplete="disabled"
                  />
                  <Form.Field
                    control={Input}
                    label="Address (line 2)"
                    value={member.addressLine2}
                    onChange={this.onChangeValue}
                    name="addressLine2"
                    fluid
                    autoComplete="disabled"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Field
                    control={Input}
                    label="City"
                    value={member.city}
                    onChange={this.onChangeValue}
                    name="city"
                    width="8"
                    required
                    autoComplete="disabled"
                  />
                  <StateSelector
                    member={member}
                    fieldChangeHandler={this.onChangeValue}
                    fieldkey="stateField"
                    width="5"
                    required
                  />
                  <Form.Field
                    control={Input}
                    label="Zip/Postal Code"
                    value={member.zipCode}
                    onChange={this.onChangeValue}
                    name="zipCode"
                    width="3"
                    required
                    autoComplete="disabled"
                  />
                </Form.Group>
                <CountrySelector
                  member={member}
                  fieldChangeHandler={this.onChangeValue}
                  width="4"
                  required
                />
                <Form.Field
                  control={Input}
                  label="Phone"
                  value={member.phoneNumber}
                  onChange={this.onChangeValue}
                  name="phoneNumber"
                  placeholder="5555555555"
                  width="4"
                  autoComplete="disabled"
                  maxLength="10"
                  onKeyPress={this.onKeyPressExecute}
                />
                <Form.Field
                  control={Input}
                  label="Email Address"
                  value={member.emailAddress}
                  onChange={this.onChangeValue}
                  name="emailAddress"
                  required={!isPCICompliantForPayments(this.props)}
                  width="12"
                  autoComplete="disabled"
                />
                <Form.Field
                  control={Checkbox}
                  label="Please send membership materials to me in Spanish when available."
                  onChange={this.onChangeSpanishMaterial}
                  name="spanishMaterial"
                  checked={member.spanishMaterial}
                />
                <div styleName="member-info spouse-info">
                  <Header as="h3" dividing>
                    Spouse/Partner Information
                    <Header.Subheader>
                      Membership fee includes spouse/partner <b>free</b>.
                    </Header.Subheader>
                    <Header.Subheader>
                      Your spouse will also receive a membership card.
                    </Header.Subheader>
                  </Header>
                  <Form.Group widths="equal">
                    <Form.Field
                      control={Input}
                      label="First Name"
                      value={member.spouseFirstName}
                      onChange={this.onChangeValue}
                      name="spouseFirstName"
                      fluid
                      autoComplete="disabled"
                    />
                    <Form.Field
                      control={Input}
                      label="Middle Name"
                      value={member.spouseMiddleName}
                      onChange={this.onChangeValue}
                      name="spouseMiddleName"
                      fluid
                      autoComplete="disabled"
                    />
                    <Form.Field
                      control={Input}
                      label="Last Name"
                      value={member.spouseLastName}
                      onChange={this.onChangeValue}
                      name="spouseLastName"
                      fluid
                      autoComplete="disabled"
                    />
                  </Form.Group>
                  <Form.Group>
                    <DateOfBirth
                      member={member}
                      fieldChangeHandler={this.onChangeValue}
                      memberLevel="spouse"
                    />
                    <Form.Field
                      control={Input}
                      label="Email Address"
                      value={member.spouseEmailAddress}
                      onChange={this.onChangeValue}
                      name="spouseEmailAddress"
                      width="12"
                      autoComplete="disabled"
                    />
                  </Form.Group>
                </div>
              </div>
              <Button styleName="action-button" type="button" onClick={this.submit}>Save</Button>
              <Button type="button" styleName="action-button" onClick={this.handleCancel}>Cancel</Button>
            </Form>
          </div>
        </Dimmer.Dimmable>
      </div>
    );
  }
}

export default EditMember;



// WEBPACK FOOTER //
// ./src/app/components/EditMember/index.js